import {StatusIcons} from "assets/icons/status/status.index";
import theme from "theme/theme";
import { en } from "language/en";
import {StatusItem} from "assets/arrayList/ProjectStatus";
const enTask = en.screen.Task.status;

const hasRejection : StatusItem = {
  title: enTask.hasRejection,
  icon: StatusIcons.HasRejection,
  color: theme.palette.error.main,
  checked: false,
}

export default hasRejection